<template>
    <div class="mesin-edc-content">
        <SOSlotBase :container-name="'pilih-pembayaran-content'" :loading="!formReady">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar :page-title="`Pilih Pembayaran`" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-t-16 f-c-black f-regular f-14 relative" v-if="formReady">
                    <div class="p-x-20">
                        Pilih pembayaran yang ingin diikutkan dengan settlement ini.
						<SOInputCheckbox
							:checkboxes="selectAllCheck"
							:checked="isSelectAll"
							@selected="(val) => { toggleSelectAll(val) }"
						/>
                    </div>
                    <div class="pembayaran-list p-x-20 p-t-16">
                        <ExpandCheckList
                            ref="checkList"
                            :data-list="listPembayaran"
                            :child-index="`list_riwayat_pembayaran`"
                            :selected="selectedPembayaran"
                            @toggleItemSelected="toggleCheck"
                            @toogleCheckAll="onCheckAll"
                        />
                    </div>
                    <div class="absolute d-grid-12 p-x-20 responsive-item" id="pilih-pembayaran-action">
                        <div class="grid-cspan-6 a-self-center">
                            <p class="m-d-0 f-12 f-c-midgrey">{{ totalItem }} Pembayaran</p>
                            <p class="m-d-0 f-16">{{ totalPembayaran | currency }}</p>
                        </div>
                        <div class="grid-cspan-6 a-self-center">
                            <SOButton
                                :primary="true"
                                text="Lanjutkan"
                                :full="true"
                                :id="`btn-next-settlement`"
                                :disable="totalItem === 0"
                                @action="nextStep"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

import SOButton from "@/so-components/global/ui/SOButton";

import ExpandCheckList from "../components/ExpandCheckList.vue";

import { moduleName } from "../store/state";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox.vue";

export default {
    name: "PilihPembayaran",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOButton,
        ExpandCheckList,
		SOInputCheckbox,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (
                from.name === "mesin.edc.pilih.pembayaran.buat.settlement" ||
                from.name === "mesin.edc.pilih.pembayaran.batal"
            ) {
                vm.setBackTo(vm.$route.query.backto);
            } else {
                vm.setBackTo(from.name);
            }
            if (
                from.name !== "mesin.edc.pilih.pembayaran.buat.settlement" &&
                from.name !== "mesin.edc.pilih.pembayaran.batal"
            ) {
                if (to.name !== "mesin.edc.pilih.pembayaran.batal") {
                    vm.init();
                }
            } else {
                vm.setFormReady(true);
            }
        });
    },
    data() {
        return {
            formReady: false,
            backTo: "mesin.edc.list",
			isSelectAll: false,
			selectAllCheck: {
				name: "pilih-semua",
				data: [
					{
						id: "pilih-semua",
						value: "1",
						title: "Pilih semua",
						checked: true,
						titleBold: false,
					},
				]
			},
        };
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormReady(true);
            }
        },
        formReady: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                if (newVal && document.getElementById("nav-bottom").classList.length > 0) {
                    setTimeout(() => {
                        document.getElementById("pilih-pembayaran-action").classList.add("set-responsive");
                    }, 100);
                }
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            response: "response",
            isFetching: "isFetching",
            listPembayaran: "listPembayaran",
            selectedPembayaran: "selectedPembayaran",
        }),
        idedc() {
            return this.$route.params.id_mesin;
        },
        totalPembayaran() {
            let total = 0;
            this.selectedPembayaran.forEach((data) => {
                data.items.forEach((item) => {
                    total += item.nominal;
                });
            });

            return total;
        },
        totalItem() {
            let total = 0;
            this.selectedPembayaran.forEach((data) => {
                total += data.items.length;
            });

            return total;
        },
    },
    mounted() {
        if (this.listPembayaran.length > 0) {
            this.setFormReady(true);
        }
        this.smartTrackingView("add_settlement_mesin_edc_step_1");
    },
    methods: {
        ...mapActions({
            getListPembarayan: `${moduleName}/getListPembarayan`,
            toggleItem: `${moduleName}/toggleItem`,
            toggleCheckParent: `${moduleName}/toggleCheckParent`,
            getDetailMesin: `${moduleName}/getDetailMesin`,
			toggleSelectAllPembayaran: `${moduleName}/toggleSelectAllPembayaran`,
        }),
        async init() {
            await this.getDetailMesin(this.idedc);
            await this.getListPembarayan(this.idedc);
        },
        setFormReady(val) {
            this.formReady = val;
        },
        back() {
            let pushTo = { name: this.backTo };
            if (this.totalItem > 0) {
                pushTo = { name: "mesin.edc.pilih.pembayaran.batal", query: { backto: this.backTo } };
            }
            this.$router.push(pushTo);
        },
        toggleCheck(param) {
            this.toggleItem(param);
        },
        onCheckAll(param) {
            this.toggleCheckParent(param);
        },
        setBackTo(val) {
            this.backTo = val;
        },
        nextStep() {
            this.$router.push({ name: "mesin.edc.pilih.pembayaran.buat.settlement", query: { backto: this.backTo } });
            this.smartTrackingClick("add_settlement_mesin_edc_step_2");

        },
		toggleSelectAll(val) {
			this.isSelectAll = val
			this.toggleSelectAllPembayaran(this.isSelectAll)
		}
    },
};
</script>
<style scoped>
.relative {
    position: relative;
    height: 100vh;
    padding-bottom: 67px;
}
.absolute {
    position: fixed;
    width: 100vw;
    bottom: 66px;
    background-color: #ffffff;
}
.pembayaran-list {
    padding-bottom: 130px;
}

@media (min-width: 768px) {
    .relative .set-responsive {
        padding-right: 390px;
    }
}
</style>
